module.exports = __webpack_public_path__ + "static/media/dash1.ab6ffd89.png";